import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';
 
import { ModelError } from '@hub/models/ModelError';
 
@Directive({
  selector: '[validation]'
})
export class ValidationDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) { }
 
  @Input() public OnlyHighlight: boolean = false;
 
  @Input('tableValidation') public tableValidation: boolean = false;
 
  @Input('key') public Key: string;
 
  @Input('equalsKey') public EqualsKey: boolean = true;
 
  @Input('showfieldandtableerrors')
  public showfieldandtableerrors: boolean = false;
 
  @Input('validation')
  public set Errors(errors: ModelError[]) {
    if (!!errors && errors.length > 0 && Array.isArray(errors)) {
      if (!!this.Key) {
        this.MyErrors = errors.filter(modelError => {
          if (
            !modelError.IsShown &&
            ((this.EqualsKey && modelError.Key === this.Key) ||
              (!this.EqualsKey && modelError.Key.indexOf(this.Key) === 0))
          ) {
            modelError.IsShown = true;
 
            return true;
          }
 
          return false;
        });
      } else {
        if (this.showfieldandtableerrors) {
          this.MyErrors = errors.filter(
            error => !error.IsShown && error.Key == ''
          );
        } else {
          this.MyErrors = errors.filter(error => !error.IsShown);
        }
      }
    } else {
      this.MyErrors = [];
    }
 
    this.renderErrors();
  }
 
  private MyErrors: ModelError[] = [];
 
  private ErrorHolder: any;
 
  private get HasError(): boolean {
    return this.MyErrors.some(i => i.Messages.length > 0);
  }
 
  private renderErrors(): void {
    if (!!this.tableValidation) {
      this.createTableErrorHolder();
 
      if (!this.OnlyHighlight) {
        this.MyErrors.forEach(errorGroup => {
          const errorGroupHolder = this.createTableGroupHolder();
 
          errorGroup.Messages.forEach(error => {
            this.createTableMessageHolder(errorGroupHolder, error);
          });
        });
      }
    } else {
      this.createErrorHolder();
 
      if (!this.OnlyHighlight) {
        this.MyErrors.forEach(errorGroup => {
          const errorGroupHolder = this.createGroupHolder();
 
          errorGroup.Messages.forEach(error => {
            this.createMessageHolder(errorGroupHolder, error);
          });
        });
      }
    }
  }
 
  private createTableErrorHolder(): void {
    if (!!this.ErrorHolder) {
      this.el.nativeElement.removeChild(this.ErrorHolder);
    }
 
    if (this.HasError) {
      this.renderer.addClass(this.el.nativeElement, 'invalid');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'invalid');
    }
 
    this.ErrorHolder = this.renderer.createElement('div');
    this.renderer.appendChild(this.el.nativeElement, this.ErrorHolder)
    this.renderer.addClass(this.ErrorHolder, 'col-xs-12');
    this.renderer.addClass(this.ErrorHolder, 'validation-message');
  }
 
  private createTableGroupHolder(): any {
    const innerDiv = this.renderer.createElement('div');
    this.renderer.appendChild(this.ErrorHolder, innerDiv);
    this.renderer.addClass(innerDiv, 'row');
 
    return innerDiv;
  }
 
  private createTableMessageHolder(parentNode: any, message: string): void {
    const errorDiv = this.renderer.createElement('div');
    this.renderer.appendChild(parentNode, errorDiv);
    this.renderer.addClass(parentNode, 'has-error');
    this.renderer.addClass(parentNode, 'padding-left-5-xs');

    this.renderer.appendChild(errorDiv, this.renderer.createText(message));
  }
 
  private createErrorHolder(): void {
    if (!!this.ErrorHolder) {
      this.el.nativeElement.removeChild(this.ErrorHolder);
    }
 
    if (this.HasError) {
      this.renderer.addClass(this.el.nativeElement, 'invalid');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'invalid');
    }
 
    this.ErrorHolder = this.renderer.createElement('div');
    this.renderer.appendChild(this.el.nativeElement, this.ErrorHolder);
    this.renderer.addClass(this.ErrorHolder, 'col-xs-12');
    this.renderer.addClass(this.ErrorHolder, 'validation-message');
  }
 
  private createGroupHolder(): any {
    const innerDiv = this.renderer.createElement( 'div');
    this.renderer.appendChild(this.ErrorHolder, innerDiv);
    this.renderer.addClass(innerDiv, 'row');
 
    return innerDiv;
  }
 
  private createMessageHolder(parentNode: any, message: string): void {
    const errorDiv = this.renderer.createElement('div');
    this.renderer.appendChild(parentNode, errorDiv)
    this.renderer.addClass(errorDiv, 'col-xs-12');
    this.renderer.addClass(errorDiv, 'text-right');

    this.renderer.appendChild(errorDiv, this.renderer.createText(message));
  }
}